import { render, staticRenderFns } from "./PensionInstrumentDetailsView.vue?vue&type=template&id=28d78e7b&scoped=true&"
import script from "./PensionInstrumentDetailsView.vue?vue&type=script&lang=ts&"
export * from "./PensionInstrumentDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./PensionInstrumentDetailsView.vue?vue&type=style&index=0&id=28d78e7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d78e7b",
  null
  
)

export default component.exports